import { Typography } from "@commonlibs";
import styled, { css } from "styled-components";

export const MainDrawerLinkRoot = styled(Typography)(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: 10px;
        width: fit-content;
        cursor: pointer;
        color: ${theme.palette.gray[0]};
        font-size: 20px;
        &:hover {
            text-decoration: underline;
            color: ${theme.palette.gray[0]};
        }
    `,
);

export const LinkIcon = styled.div(
    () => css`
        font-size: 1.7rem;
        color: white;
        cursor: pointer;
    `,
);
